import _ from "lodash";
import {IntervalMode, Interval, IntervalEnumLabels} from "./Interval";
import moment from "moment";


export class Value {
    public mode: IntervalMode | null;
    interval: Interval;
    date: Date | null;

    static createByInterval(mode: IntervalMode): Value {
        const value = new Value();
        value.mode = mode;
        value.interval = Interval.createByMode(mode);
        return value;
    }

    static createByDate(date: Date): Value {
        const start = _.clone(date);
        start.setHours(0, 0, 0);

        const end = _.clone(date);
        end.setHours(23, 59, 59);

        const value = new Value();
        value.date = _.clone(date);
        value.interval = new Interval(start, end);

        return value;
    }

    static createByPeriod(start: Date|null, end: Date|null): Value {
        const value = new Value();
        value.interval = new Interval(start, end);

        return value;
    }

    toString(): string {
        if (this.mode) {
            return IntervalEnumLabels(this.mode);
        }
        if (this.date) {
            return moment(this.date).format('ll');
        }

        return this.interval.toString();
    }
}
